import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserModel } from 'src/app/core/data-sources/user-data-source.service';
import { ActionService } from 'src/app/core/services/action.service';
import { ErrorsEnum } from 'src/app/core/services/error.service';
import { UserRoles } from 'src/models/User';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  hidePassword = true;
  hideConfirmPassword = true;
  passwordPatternMessage: string = '';
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { user: UserModel, showWarning: boolean },
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    private actionService: ActionService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  close() {
    this.dialogRef.close(false);
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.actionService.changeUserPassword({
      newPassword: this.form.value.confirmPassword,
      userId: this.data.user.id
    }).then(() => {
      this.form.reset();
      this.dialogRef.close(this.data.user.id);
    }).catch(error => {
      this.form.reset();
      if (error.type === ErrorsEnum.USER_ERROR_INVALID_PASSWORD_PATTERN) {
        this.form.controls.password.setErrors({ invalid: true });
      }
    });
  }

  public get controls() {
    return this.form.controls;
  }

  getPasswordValidators(type: string): { validators: ValidatorFn[], message: string } {
    let pattern: RegExp;
    let message: string;

    switch (type) {
      case UserRoles.MASTER:
      case UserRoles.ADMIN:
        pattern = /^[A-Za-z0-9]{6,20}$/;
        message = 'A senha deve conter de 6 e 20 caracteres alfanuméricos. Não use caracteres especiais.';
        break;

      case UserRoles.OPERATOR:
      case UserRoles.MANAGER:
        pattern = /^\d{6,8}$/;
        message = 'A senha deve conter de 6 a 8 números.';
        break;

      default:
        pattern = /.{6,}/;
        message = 'A senha deve conter pelo menos 6 caracteres.';
        break;
    }

    return { validators: [Validators.pattern(pattern)], message };
  }

  initializeForm(): void {
    const { validators, message } = this.getPasswordValidators(this.data.user.type);
    this.passwordPatternMessage = message;

    this.form = this.formBuilder.group({
      password: ['', [Validators.required, ...validators]],
      confirmPassword: ['', Validators.required]
    }, {
      validators: passwordMatchValidator
    });
  }

}

export function passwordMatchValidator(control) {
  const newPassword = control.get('password');
  const confirmPassword = control.get('confirmPassword');

  if (!newPassword || !confirmPassword || !newPassword.value || !confirmPassword.value) {
    return null;
  }

  if (newPassword.value !== confirmPassword.value) {
    confirmPassword.setErrors({ passwordMismatch: true });
    return { passwordMismatch: true };
  } else {
    confirmPassword.setErrors(null);
    return null;
  }
}
